import React from 'react';


export default class Health extends React.Component {
    render() {
        return (
            <div>I'm good :)</div>
        )        
    }
}



// WEBPACK FOOTER //
// ./src/components/Health.js